<app-widget-card-wrapper [title]="chartTitle">
  <h1 *ngIf="showHeader" class="card-title-medium">Annual Volume m3</h1>
  <div class="card-stretch">
    <div echarts [options]="methaneCDChartOption" class="demo-chart"></div>
  </div>
</app-widget-card-wrapper>
